import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import './Layout.css';

function MainLayout() {
  return (
    <div className="main-layout">
      <Header />
      <main className="main-content">
        <Outlet />
      </main>
      <footer className="main-footer">
        <small>MailWatch v1.0.0 • Email Tracking for Gmail</small>
      </footer>
    </div>
  );
}

export default MainLayout;
